"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antDesignVue = require("ant-design-vue");
// https://www.antdv.com/components/modal-cn/#API
var _default = exports.default = {
  name: 'BasisModal',
  // 模态对话框
  props: {
    ..._antDesignVue.Modal.props,
    value: {
      type: Boolean,
      default: false
    },
    // 可用于设置浮层的样式，调整浮层位置等
    dialogStyle: {
      type: Object,
      default: () => {
        return {
          top: '8vh'
        };
      }
    },
    bodyStyle: {
      type: Object,
      default: () => {
        return {
          'max-height': '70vh',
          'overflow-y': 'auto'
        };
      }
    },
    // 关闭时销毁 Modal 里的子元素
    destroyOnClose: {
      type: Boolean,
      default: true
    },
    // 宽度 尺寸定义：默认对话框宽度为680px ；最大对话框宽度为960px；特殊业务场景可提供自定义宽度
    width: {
      type: [Number, String],
      // type为String时需要带上px单位，如 680px
      default: 680
    },
    // 自定义属性 - 宽度尺寸大小，是width的别名
    size: {
      type: String,
      default: null,
      // default 680 | large or lg 960
      validator: value => {
        return ['', 'small', 'default', 'large', 'lg'].includes(value);
      }
    },
    // 自定义属性 - 模态框内部的最小高度
    minHeight: {
      type: String,
      default: '40vh'
    }
  },
  data() {
    return {
      localVisible: false,
      spinning: false,
      sizeMap: {
        small: 520,
        default: 680,
        large: 960,
        lg: 960
      }
    };
  },
  watch: {
    value: {
      handler(val) {
        this.localVisible = val;
      },
      immediate: true
    },
    visible: {
      handler(val) {
        this.localVisible = val;
      },
      immediate: true
    },
    confirmLoading: {
      handler(val) {
        this.spinning = val;
      },
      immediate: true
    }
  },
  methods: {
    // 点击遮罩层或右上角叉或取消按钮的回调
    handleCancel(e) {
      this.$emit('cancel', e);
      this.$emit('input', false);
    },
    // 点击确定回调
    handleOk(e) {
      this.$emit('ok', e);
    }
  }
};